import { colorsPalettes } from "@similarweb/styles";

// High Level Metrics Chart Colors
export const CHART_COLORS = {
    // Web Source colors for segmented charts (Desktop vs Mobile Web)
    DESKTOP: colorsPalettes.blue[400],
    MOBILE_WEB: colorsPalettes.sky[300],

    // Period over period comparison colors for "All Traffic" mode
    CURRENT_PERIOD: colorsPalettes.blue[400],
    PREVIOUS_PERIOD: colorsPalettes.orange[400],

    // Default fallback color for legend items
    DEFAULT_LEGEND: colorsPalettes.blue[400],

    // Chart styling colors
    CHART_GRID: colorsPalettes.carbon[200],
    TOOLTIP_TEXT: colorsPalettes.carbon[100],
} as const;
